import { BottomTabNavigationProp } from '@react-navigation/bottom-tabs'
import {
  CompositeNavigationProp,
  ParamListBase,
} from '@react-navigation/native'
import { StackNavigationProp } from '@react-navigation/stack'
import { Text } from '@rneui/themed'
import { ConversationTabParamList } from 'chat/conversations/types'
import { FileFoldersBottomTabParamList } from 'file_folder_repository/chat_group_folders/stack/types'
import { HomeStackParamList } from 'home/stack/types'
import { Platform } from 'react-native'

export function showHeaderTitle<
  ParamList extends ParamListBase,
  RouteName extends keyof ParamList
>(
  navigation:
    | StackNavigationProp<ParamList, RouteName>
    | CompositeNavigationProp<
        BottomTabNavigationProp<ConversationTabParamList>,
        StackNavigationProp<HomeStackParamList>
      >
    | CompositeNavigationProp<
        BottomTabNavigationProp<FileFoldersBottomTabParamList>,
        StackNavigationProp<HomeStackParamList>
      >,
  title: string
) {
  navigation.setOptions({
    title,
    headerTitleAllowFontScaling: false,
    headerTitle: props => (
      <Text
        allowFontScaling={props.allowFontScaling}
        numberOfLines={1}
        textBreakStrategy="simple"
        style={[
          Platform.select({
            ios: [
              {
                fontSize: 17,
                fontWeight: '600',
                lineHeight: 23,
              },
            ],
            android: {
              fontSize: 20,
              fontFamily: 'sans-serif-medium',
              fontWeight: 'normal',
              lineHeight: 27,
            },
            default: {
              fontSize: 18,
              fontWeight: '500',
              lineHeight: 24,
            },
          }),
          {
            width: '100%',
            color: props.tintColor,
          },
        ]}
      >
        {title}
      </Text>
    ),
    headerTitleContainerStyle: {
      marginHorizontal: 0,
      flexShrink: 1,
    },
  })
}
